module.exports = __webpack_public_path__ + "static/media/bbtsaxcLogo.e2165f2c.png";